import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  head: () => pageHead("AKIVA | AI Engineering & Strategy Consulting", "AKIVA delivers enterprise AI solutions including machine learning, multi-agent systems, MLOps, and strategy consulting for government and commercial clients.", "/", false),
  component: Index,
});
